var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-top"},[_c('div',{staticClass:"nav-titlebar"},[(_vm.backShow)?_c('div',{staticClass:"back",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("@/assets/yq/back.png")}})]):_vm._e(),_c('div',{staticClass:"bar-title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }